import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'

export type LookupSiteRequestPayload = {
  sitePath: string
  getEncryptionKey?: boolean
  getFileHashesForVersion?: string
  checkReauth?: boolean
}

export const LookupSiteRequestPayloadSchema: CborSchema<LookupSiteRequestPayload> =
  defineCborSchema<LookupSiteRequestPayload>({
    sitePath: CborField({ key: 0 }),
    getEncryptionKey: CborField({ key: 1, required: false }),
    getFileHashesForVersion: CborField({ key: 2, required: false }),
    checkReauth: CborField({ key: 3, required: false }),
  })
